import {HostPageMessenger} from './HostPageMessenger';
import {inIframe} from './inIframe';

// Populate `window.iFrameResizer` BEFORE the iframe-resizer contentWindow script
// runs. The two are wired together by static imports in `src/index.tsx` — this
// module must be imported first so the assignment lands ahead of the child
// script reading it.
//
// This lived inline in index.tsx pre-migration alongside a synchronous CJS
// `require('iframe-resizer/js/iframeResizer.contentWindow')`. Vite has no
// synchronous side-effect import equivalent, so the config move + import
// ordering is what preserves the pre-migration load semantics.

const IFRAME_PARENT_ORIGIN: string = import.meta.env.VITE_IFRAME_PARENT_ORIGIN || (() => {
  const url = new URL(window.location.href);
  const stem = url.host.split('.').slice(1);
  if (stem[stem.length - 2] === 'zaius') {
    url.host = 'app.zaius.com';
    if (stem[0] === 'staging') {
      url.host = 'staging.zaius.com';
    }
    return url.origin;
  }
  stem[1] = 'odp';
  url.host = ['app'].concat(stem).join('.');
  return url.origin;
})();

if (inIframe()) {
  window.iFrameResizer = {
    targetOrigin: IFRAME_PARENT_ORIGIN,
    onMessage: (message: any) => HostPageMessenger.receive(message),
    onReady: () => HostPageMessenger.receive({method: 'ready'}),
  };
}
